import { render, staticRenderFns } from "./ImportFile.vue?vue&type=template&id=24292d40&scoped=true&"
import script from "./ImportFile.vue?vue&type=script&lang=js&"
export * from "./ImportFile.vue?vue&type=script&lang=js&"
import style0 from "./ImportFile.vue?vue&type=style&index=0&id=24292d40&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24292d40",
  null
  
)

export default component.exports